import { mapMutations, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  methods: {
    ...mapMutations({
      _setData: 'reconciliationDetails/setDetails',
    }),
    ...mapActions({
      _uploadData: 'reconciliationDetails/uploadDetails',
    }),
  },
  computed: {
    ...mapGetters({
      details: 'reconciliationDetails/getDetails',
    }),
    data: {
      get() {
        return this.details;
      },
      set(val) {
        this._setData(val);
      },
    },
  },
  watch: {
    data() {
      this.throttledMethod = _.debounce(() => {
        this._uploadData;
      }, 1000);
    },
  },
};
